export interface Comic {
  id: number;
  title: string;
  slug: string;
  author: string;
  coverUrl: string;
  description: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  updateDate: string;
  totalChapters: number;
  rating: number;
  views: number;
  chapters: Chapter[];
}

export interface Chapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'remen', name: '热门推荐', description: '最受欢迎的韩漫作品推荐', count: 48 },
  { slug: 'lianai', name: '恋爱', description: '浪漫甜蜜的恋爱韩漫', count: 156 },
  { slug: 'qihuan', name: '奇幻', description: '充满想象力的奇幻韩漫', count: 89 },
  { slug: 'dongzuo', name: '动作', description: '热血刺激的动作韩漫', count: 72 },
  { slug: 'xuanyi', name: '悬疑', description: '扣人心弦的悬疑韩漫', count: 54 },
  { slug: 'danmei', name: '耽美', description: '唯美动人的耽美韩漫', count: 120 },
  { slug: 'wanjie', name: '完结', description: '已完结的经典韩漫', count: 200 },
  { slug: 'dushi', name: '都市', description: '现代都市生活韩漫', count: 95 },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '秘密花园',
    slug: 'mimi-huayuan',
    author: '金恩淑',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20romantic%20fantasy%20story%20elegant%20woman%20in%20flower%20garden%20with%20soft%20watercolor%20style%20warm%20pastel%20tones%20delicate%20linework%20dreamy%20atmosphere%20clean%20minimal%20background%20vertical%20comic%20cover%20illustration%20style&width=400&height=560&seq=comic-cover-1&orientation=portrait',
    description: '《秘密花园》讲述了富家千金与普通青年之间跨越阶层与命运的浪漫爱情故事。在一次偶然的机会下，两人在祖父留下的秘密花园中相遇，从此展开了一段充满波折却又甜蜜动人的爱情旅程。作品以其细腻的画风和感人的剧情赢得了无数读者的喜爱，是韩国漫画中不可错过的经典之作。',
    category: 'lianai',
    tags: ['浪漫', '都市', '治愈', '少女'],
    status: '已完结',
    updateDate: '2026-08-01',
    totalChapters: 86,
    rating: 4.8,
    views: 3280000,
    chapters: [
      { id: 1, title: '第1话 秘密花园的相遇', updateDate: '2025-01-15' },
      { id: 2, title: '第2话 花园里的约定', updateDate: '2025-01-22' },
      { id: 85, title: '第85话 最后的告白', updateDate: '2026-07-25' },
      { id: 86, title: '第86话 永恒的花园（完结）', updateDate: '2026-08-01' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法',
    slug: 'jian-yu-mofa',
    author: '朴志浩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20cover%20male%20warrior%20wielding%20glowing%20sword%20with%20magical%20aura%20dramatic%20lighting%20intense%20battle%20stance%20dark%20atmospheric%20background%20with%20magical%20particles%20epic%20composition%20vertical%20comic%20illustration%20style%20clean%20and%20striking%20colors&width=400&height=560&seq=comic-cover-2&orientation=portrait',
    description: '在剑与魔法交织的异世界中，平凡少年艾伦意外觉醒了传说中的双系魔力，成为了能够同时驾驭剑术与魔法的唯一存在。为了守护所爱之人，他踏上了对抗黑暗势力的冒险之旅。本作以其宏大的世界观、精彩的战斗场景和深入人心的角色塑造，成为了奇幻类韩漫的代表作品。',
    category: 'qihuan',
    tags: ['冒险', '战斗', '异世界', '少年'],
    status: '连载中',
    updateDate: '2026-08-03',
    totalChapters: 134,
    rating: 4.7,
    views: 4510000,
    chapters: [
      { id: 1, title: '第1话 觉醒之日', updateDate: '2024-06-10' },
      { id: 2, title: '第2话 剑术之道', updateDate: '2024-06-17' },
      { id: 133, title: '第133话 黑暗降临', updateDate: '2026-07-27' },
      { id: 134, title: '第134话 最后的试炼', updateDate: '2026-08-03' },
    ],
  },
  {
    id: 3,
    title: '都市夜话',
    slug: 'dushi-yehua',
    author: '李美淑',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20drama%20cover%20stylish%20young%20professionals%20in%20modern%20city%20night%20scene%20neon%20lights%20reflecting%20on%20wet%20streets%20sophisticated%20atmosphere%20muted%20color%20palette%20with%20warm%20accent%20lighting%20emotional%20storytelling%20vibe%20vertical%20comic%20cover%20illustration&width=400&height=560&seq=comic-cover-3&orientation=portrait',
    description: '《都市夜话》以首尔繁华的都市为背景，描绘了一群年轻人在快节奏的都市生活中追寻梦想与爱情的故事。职场竞争、友情羁绊、爱情纠葛，每一个角色都鲜活立体，故事真实而动人。作品以其对当代都市生活的深刻洞察和精致画风，成为都市题材韩漫的标杆之作。',
    category: 'dushi',
    tags: ['职场', '爱情', '生活', '青年'],
    status: '连载中',
    updateDate: '2026-08-02',
    totalChapters: 96,
    rating: 4.5,
    views: 2190000,
    chapters: [
      { id: 1, title: '第1话 首尔的夜晚', updateDate: '2025-03-20' },
      { id: 2, title: '第2话 新的开始', updateDate: '2025-03-27' },
      { id: 95, title: '第95话 选择的路', updateDate: '2026-07-26' },
      { id: 96, title: '第96话 灯火阑珊处', updateDate: '2026-08-02' },
    ],
  },
  {
    id: 4,
    title: '王妃的重生',
    slug: 'wangfei-de-chongsheng',
    author: '崔秀英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20cover%20beautiful%20princess%20in%20elegant%20traditional%20Korean%20hanbok%20palace%20garden%20background%20with%20cherry%20blossoms%20soft%20dreamy%20lighting%20delicate%20facial%20expression%20warm%20color%20palette%20vertical%20comic%20cover%20elegant%20artistic%20style&width=400&height=560&seq=comic-cover-4&orientation=portrait',
    description: '被陷害致死的王妃李素妍重生回到了十年前。带着前世所有的记忆，她决心改变命运的轨迹，向那些曾经伤害过她的人复仇，同时守护她真正珍惜的人。本作融合了古装、重生、复仇与爱情元素，剧情紧凑刺激，反转不断，是近年来最受欢迎的宫廷重生题材韩漫之一。',
    category: 'wanjie',
    tags: ['重生', '宫斗', '复仇', '古装'],
    status: '已完结',
    updateDate: '2026-07-15',
    totalChapters: 72,
    rating: 4.9,
    views: 6120000,
    chapters: [
      { id: 1, title: '第1话 死亡与重生', updateDate: '2025-08-01' },
      { id: 2, title: '第2话 回到十年前', updateDate: '2025-08-08' },
      { id: 71, title: '第71话 最后的审判', updateDate: '2026-07-08' },
      { id: 72, title: '第72话 新的人生（完结）', updateDate: '2026-07-15' },
    ],
  },
  {
    id: 5,
    title: '暗夜追踪者',
    slug: 'anye-zhuizongzhe',
    author: '郑宇成',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20noir%20cover%20mysterious%20detective%20in%20trench%20coat%20standing%20in%20dark%20rainy%20alley%20dramatic%20shadows%20and%20light%20intense%20atmosphere%20monochromatic%20tones%20with%20red%20accent%20suspenseful%20mood%20vertical%20comic%20cover%20cinematic%20noir%20style&width=400&height=560&seq=comic-cover-5&orientation=portrait',
    description: '首尔连续发生离奇命案，刑警韩道允在追查过程中发现了隐藏在案件背后惊人的真相——一个涉及政商名流的庞大犯罪网络。步步紧逼的危险、扑朔迷离的线索、紧张刺激的追逐战，让你喘不过气来。本作以其紧凑的剧情和出人意料的反转，被誉为韩国悬疑漫画的天花板之作。',
    category: 'xuanyi',
    tags: ['刑侦', '犯罪', '推理', '惊悚'],
    status: '连载中',
    updateDate: '2026-08-01',
    totalChapters: 58,
    rating: 4.6,
    views: 1870000,
    chapters: [
      { id: 1, title: '第1话 第一起命案', updateDate: '2025-11-10' },
      { id: 2, title: '第2话 蛛丝马迹', updateDate: '2025-11-17' },
      { id: 57, title: '第57话 绝境', updateDate: '2026-07-25' },
      { id: 58, title: '第58话 幕后黑手', updateDate: '2026-08-01' },
    ],
  },
  {
    id: 6,
    title: '甜蜜暴击',
    slug: 'tianmi-baoji',
    author: '姜恩智',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sweet%20romance%20cover%20cute%20young%20couple%20sharing%20earphones%20on%20school%20rooftop%20cherry%20blossom%20petals%20floating%20bright%20warm%20sunlight%20pastel%20pink%20and%20mint%20color%20scheme%20youthful%20and%20fresh%20atmosphere%20vertical%20comic%20illustration%20clean%20art%20style&width=400&height=560&seq=comic-cover-6&orientation=portrait',
    description: '校园里最冷漠的学霸校草和活泼可爱的转学生之间发生的甜蜜爱情故事。一个是高傲冷峻的全校第一，一个是元气满满的阳光少女，截然不同的两人因一次意外而产生了交集。从开始的针锋相对到后来的甜蜜暴击，这部作品用温暖治愈的画风和令人心动的剧情，俘获了无数读者的少女心。',
    category: 'lianai',
    tags: ['校园', '甜宠', '青春', '成长'],
    status: '已完结',
    updateDate: '2026-06-20',
    totalChapters: 64,
    rating: 4.7,
    views: 3890000,
    chapters: [
      { id: 1, title: '第1话 意外的相遇', updateDate: '2025-05-01' },
      { id: 2, title: '第2话 冷面学霸', updateDate: '2025-05-08' },
      { id: 63, title: '第63话 毕业季', updateDate: '2026-06-13' },
      { id: 64, title: '第64话 永远的甜蜜（完结）', updateDate: '2026-06-20' },
    ],
  },
  {
    id: 7,
    title: '魔王的养女',
    slug: 'mowang-de-yangnv',
    author: '尹智敏',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20drama%20cover%20young%20girl%20with%20mysterious%20powers%20standing%20before%20imposing%20demon%20king%20figure%20gothic%20castle%20interior%20magical%20glowing%20elements%20dark%20purple%20and%20gold%20color%20palette%20dramatic%20and%20emotional%20vertical%20comic%20cover%20ornate%20illustration%20style&width=400&height=560&seq=comic-cover-7&orientation=portrait',
    description: '在人类与魔族共存的世界里，一个被遗弃的人类女孩被最强大的魔王收养。在魔界成长的她，逐渐揭开了自己身世的秘密，以及那场人与魔之间持续千年的战争的真相。一边是养育她的魔族家人，一边是血浓于水的人族同胞，她将如何选择？本作以情感深度和精彩的剧情著称。',
    category: 'qihuan',
    tags: ['魔族', '亲情', '成长', '种族'],
    status: '连载中',
    updateDate: '2026-08-03',
    totalChapters: 88,
    rating: 4.8,
    views: 5120000,
    chapters: [
      { id: 1, title: '第1话 被遗弃的孩子', updateDate: '2025-07-15' },
      { id: 2, title: '第2话 魔王城堡', updateDate: '2025-07-22' },
      { id: 87, title: '第87话 真相之路', updateDate: '2026-07-27' },
      { id: 88, title: '第88话 千年的秘密', updateDate: '2026-08-03' },
    ],
  },
  {
    id: 8,
    title: '拳皇之路',
    slug: 'quanhuang-zhi-lu',
    author: '金泰亨',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20sports%20cover%20determined%20young%20fighter%20in%20boxing%20ring%20sweat%20and%20motion%20blur%20dramatic%20stadium%20lighting%20intense%20and%20gritty%20atmosphere%20warm%20sepia%20and%20red%20tones%20powerful%20composition%20vertical%20comic%20cover%20dynamic%20action%20style&width=400&height=560&seq=comic-cover-8&orientation=portrait',
    description: '出身贫寒的少年朴泰俊怀揣着成为世界拳王的梦想，在残酷的地下拳场摸爬滚打。从街头混混到职业拳手，每一步都充满鲜血与汗水。本作以极具冲击力的画风和热血的战斗场面，展现了主角不屈不挠的意志和对梦想的执着追求。每一个出拳的瞬间都让人热血沸腾。',
    category: 'dongzuo',
    tags: ['格斗', '热血', '励志', '竞技'],
    status: '连载中',
    updateDate: '2026-08-02',
    totalChapters: 76,
    rating: 4.4,
    views: 1650000,
    chapters: [
      { id: 1, title: '第1话 地下拳场', updateDate: '2025-09-01' },
      { id: 2, title: '第2话 第一场胜利', updateDate: '2025-09-08' },
      { id: 75, title: '第75话 冠军赛前夕', updateDate: '2026-07-26' },
      { id: 76, title: '第76话 擂台之上', updateDate: '2026-08-02' },
    ],
  },
  {
    id: 9,
    title: '星际恋人',
    slug: 'xingji-lianren',
    author: '朴彩英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20romance%20cover%20futuristic%20couple%20standing%20under%20starry%20galaxy%20sky%20holographic%20technology%20elements%20soft%20blue%20and%20pink%20cosmic%20colors%20romantic%20and%20ethereal%20atmosphere%20vertical%20comic%20cover%20illustration%20dreamy%20space%20fantasy%20style&width=400&height=560&seq=comic-cover-9&orientation=portrait',
    description: '2150年，地球少女林星月在一次星际旅行中邂逅了来自仙女座星系的外星王子艾瑞斯。跨越光年的距离，两个来自不同文明的人坠入爱河。然而星际政治的暗流涌动，地球与外星联盟之间的微妙关系，让这段恋情充满了未知与挑战。科幻与浪漫的完美结合。',
    category: 'lianai',
    tags: ['科幻', '星际', '异族', '未来'],
    status: '连载中',
    updateDate: '2026-08-01',
    totalChapters: 45,
    rating: 4.5,
    views: 1340000,
    chapters: [
      { id: 1, title: '第1话 星际旅程', updateDate: '2026-01-10' },
      { id: 2, title: '第2话 仙女座的王子', updateDate: '2026-01-17' },
      { id: 44, title: '第44话 文明冲突', updateDate: '2026-07-25' },
      { id: 45, title: '第45话 跨越星河的誓言', updateDate: '2026-08-01' },
    ],
  },
  {
    id: 10,
    title: '鬼怪猎人',
    slug: 'guiguai-lieren',
    author: '权相佑',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20action%20cover%20young%20exorcist%20with%20spiritual%20weapon%20fighting%20shadowy%20demon%20spirits%20ancient%20temple%20ruins%20at%20night%20blue%20spiritual%20flames%20and%20dark%20atmosphere%20dynamic%20action%20pose%20vertical%20comic%20cover%20supernatural%20thriller%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '阴阳眼少年韩智勋天生能看到常人看不见的鬼怪。在爷爷去世后，他继承了家族的鬼怪猎人身份，开始穿梭于人间与灵界，猎杀危害人间的恶灵。每个案件背后都隐藏着感人至深的故事，在惊悚之余更有着温暖的内核。本作出色的氛围营造和精彩的战斗设计让人欲罢不能。',
    category: 'dongzuo',
    tags: ['灵异', '驱魔', '热血', '感动'],
    status: '已完结',
    updateDate: '2026-05-30',
    totalChapters: 120,
    rating: 4.6,
    views: 2760000,
    chapters: [
      { id: 1, title: '第1话 觉醒的双眼', updateDate: '2024-09-15' },
      { id: 2, title: '第2话 爷爷的遗物', updateDate: '2024-09-22' },
      { id: 119, title: '第119话 最后的战斗', updateDate: '2026-05-23' },
      { id: 120, title: '第120话 猎人永存（完结）', updateDate: '2026-05-30' },
    ],
  },
  {
    id: 11,
    title: '璀璨星光',
    slug: 'cuican-xingguang',
    author: '宋慧乔',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%20two%20handsome%20young%20men%20in%20tender%20embrace%20under%20starlight%20soft%20atmospheric%20lighting%20emotional%20and%20gentle%20mood%20warm%20and%20delicate%20color%20palette%20elegant%20linework%20vertical%20comic%20cover%20beautiful%20artistic%20illustration%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '练习生时期就互相扶持的两位偶像，在出道后面对娱乐圈的光芒与阴影。从队友到恋人，从台前到幕后，他们用彼此的温度照亮对方前行的道路。面对外界的质疑和压力，他们的爱情是否经得起考验？本作以细腻的笔触描绘了一段温暖而坚定的感情。',
    category: 'danmei',
    tags: ['偶像', '娱乐圈', '温馨', '成长'],
    status: '连载中',
    updateDate: '2026-08-03',
    totalChapters: 52,
    rating: 4.8,
    views: 2980000,
    chapters: [
      { id: 1, title: '第1话 练习室的初遇', updateDate: '2025-12-01' },
      { id: 2, title: '第2话 舞台下的秘密', updateDate: '2025-12-08' },
      { id: 51, title: '第51话 绯闻风波', updateDate: '2026-07-27' },
      { id: 52, title: '第52话 选择', updateDate: '2026-08-03' },
    ],
  },
  {
    id: 12,
    title: '恶魔的契约',
    slug: 'emo-de-qiyue',
    author: '安孝燮',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20cover%20handsome%20demon%20with%20black%20wings%20making%20contract%20with%20desperate%20human%20gothic%20cathedral%20setting%20red%20and%20black%20color%20scheme%20dramatic%20lighting%20from%20below%20intense%20and%20dark%20atmosphere%20vertical%20comic%20cover%20gothic%20fantasy%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '为了拯救病危的妹妹，大学生尹振宇与一位神秘男子签订了恶魔契约。然而他并不知道，这份契约将把他卷入天使与恶魔之间延续万年的战争。在获取力量的同时，他也在逐渐失去自己的人性。当最终的选择来临时，他将站在哪一方？本作世界观宏大，人物关系错综复杂。',
    category: 'qihuan',
    tags: ['恶魔', '契约', '黑暗', '人性'],
    status: '连载中',
    updateDate: '2026-08-02',
    totalChapters: 68,
    rating: 4.5,
    views: 2030000,
    chapters: [
      { id: 1, title: '第1话 绝望中的召唤', updateDate: '2025-10-20' },
      { id: 2, title: '第2话 契约成立', updateDate: '2025-10-27' },
      { id: 67, title: '第67话 天使降临', updateDate: '2026-07-26' },
      { id: 68, title: '第68话 抉择之时', updateDate: '2026-08-02' },
    ],
  },
  {
    id: 13,
    title: '失踪的她',
    slug: 'shizong-de-ta',
    author: '河正宇',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20cover%20woman%20silhouette%20fading%20into%20dark%20mist%20fragmented%20mirror%20reflections%20unsettling%20atmosphere%20cold%20color%20palette%20with%20deep%20shadows%20mysterious%20and%20haunting%20mood%20vertical%20comic%20cover%20psychological%20horror%20style&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    description: '结婚三年的妻子突然失踪，丈夫韩泰民在寻找妻子的过程中发现了一个又一个令人震惊的秘密。妻子隐藏的身份、奇怪的邻居、诡异的电话，一切都在指向某个可怕的真相。而当真相逐渐浮出水面时，他才意识到自己从未真正了解过身边最亲近的人。',
    category: 'xuanyi',
    tags: ['失踪', '心理', '反转', '家庭'],
    status: '已完结',
    updateDate: '2026-04-10',
    totalChapters: 48,
    rating: 4.7,
    views: 2410000,
    chapters: [
      { id: 1, title: '第1话 消失的妻子', updateDate: '2025-04-01' },
      { id: 2, title: '第2话 破碎的日常', updateDate: '2025-04-08' },
      { id: 47, title: '第47话 真相浮现', updateDate: '2026-04-03' },
      { id: 48, title: '第48话 告别（完结）', updateDate: '2026-04-10' },
    ],
  },
  {
    id: 14,
    title: '办公室罗曼史',
    slug: 'bangongshi-luomanshi',
    author: '孙艺珍',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20cover%20professional%20couple%20sharing%20coffee%20in%20modern%20office%20with%20glass%20windows%20city%20skyline%20visible%20warm%20afternoon%20light%20sophisticated%20and%20romantic%20atmosphere%20beige%20and%20soft%20brown%20tones%20vertical%20comic%20cover%20clean%20modern%20illustration%20style&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    description: '在首尔最顶尖的广告公司里，新入职的菜鸟策划师与公司最冷酷的总监之间展开了一段甜蜜又爆笑的办公室恋情。白天是对下属严格到不近人情的上司，夜晚却是温柔体贴的另一半。这种双面人生会碰撞出怎样的火花？轻松搞笑的日常加上让人心动的感情线，是一部解压神作。',
    category: 'dushi',
    tags: ['职场', '甜宠', '搞笑', '反差'],
    status: '已完结',
    updateDate: '2026-07-01',
    totalChapters: 56,
    rating: 4.6,
    views: 3570000,
    chapters: [
      { id: 1, title: '第1话 入职第一天', updateDate: '2025-06-15' },
      { id: 2, title: '第2话 魔鬼总监', updateDate: '2025-06-22' },
      { id: 55, title: '第55话 公开恋情', updateDate: '2026-06-24' },
      { id: 56, title: '第56话 办公室幸福（完结）', updateDate: '2026-07-01' },
    ],
  },
  {
    id: 15,
    title: '永生之花',
    slug: 'yongsheng-zhi-hua',
    author: '李圣经',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20immortal%20fantasy%20romance%20cover%20mysterious%20immortal%20woman%20surrounded%20by%20magical%20glowing%20flowers%20ancient%20temple%20ruins%20ethereal%20beauty%20soft%20mystical%20lighting%20lavender%20and%20gold%20color%20palette%20vertical%20comic%20cover%20fantasy%20romance%20illustration&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    description: '活了千年的不死之身少女尹花，在现代首尔遇到了一位与千年前恋人长得一模一样的男子。是命运的重逢还是命运的捉弄？在追寻记忆的过程中，一段被尘封千年的禁忌之恋逐渐浮出水面。本作跨越古今，画面精美，情感细腻，是一部让人沉浸其中的浪漫奇幻作品。',
    category: 'wanjie',
    tags: ['永生', '前世', '奇幻', '命运'],
    status: '已完结',
    updateDate: '2026-06-15',
    totalChapters: 60,
    rating: 4.8,
    views: 4870000,
    chapters: [
      { id: 1, title: '第1话 千年之后', updateDate: '2025-04-15' },
      { id: 2, title: '第2话 命运的相遇', updateDate: '2025-04-22' },
      { id: 59, title: '第59话 永恒之约', updateDate: '2026-06-08' },
      { id: 60, title: '第60话 永生之花（完结）', updateDate: '2026-06-15' },
    ],
  },
  {
    id: 16,
    title: '极道风云',
    slug: 'jidao-fengyun',
    author: '马东锡',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20gangster%20action%20cover%20tough%20gangster%20in%20black%20suit%20standing%20in%20rain%20slicked%20neon%20street%20dramatic%20urban%20night%20scene%20tension%20filled%20atmosphere%20dark%20and%20gritty%20color%20tones%20powerful%20stance%20vertical%20comic%20cover%20crime%20noir%20style&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    description: '从小在帮派中长大的张赫，为了替被杀害的父亲报仇，开始了一场席卷整个首尔地下世界的复仇风暴。背叛、阴谋、兄弟情谊，在黑道世界的残酷法则中，他将如何生存？本作以暴制暴的硬核风格和复杂的人物关系，在读者中拥有极高的评价。',
    category: 'dongzuo',
    tags: ['黑道', '复仇', '兄弟', '硬核'],
    status: '连载中',
    updateDate: '2026-08-02',
    totalChapters: 82,
    rating: 4.5,
    views: 1920000,
    chapters: [
      { id: 1, title: '第1话 血染的夜晚', updateDate: '2025-08-15' },
      { id: 2, title: '第2话 地下秩序', updateDate: '2025-08-22' },
      { id: 81, title: '第81话 最后的对决', updateDate: '2026-07-26' },
      { id: 82, title: '第82话 王者归来', updateDate: '2026-08-02' },
    ],
  },
  {
    id: 17,
    title: '春日华尔兹',
    slug: 'chunri-huaerzi',
    author: '韩素希',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20spring%20romance%20cover%20two%20elegant%20young%20men%20waltzing%20in%20garden%20full%20of%20spring%20flowers%20soft%20pink%20and%20green%20pastels%20romantic%20and%20gentle%20atmosphere%20beautiful%20flowing%20movement%20portrayed%20vertical%20comic%20cover%20artistic%20and%20dreamy%20illustration%20style&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    description: '音乐学院的两位天才少年，一个专攻钢琴，一个擅长小提琴。在一次联合演奏会上，他们的音乐与灵魂完美契合。从此，一段如春日华尔兹般优美的恋情在琴键与琴弦之间缓缓展开。古典音乐的优雅与少年情感的纯粹交织在一起，成就了这部令人心醉的作品。',
    category: 'danmei',
    tags: ['音乐', '校园', '文艺', '纯爱'],
    status: '已完结',
    updateDate: '2026-05-15',
    totalChapters: 40,
    rating: 4.9,
    views: 3760000,
    chapters: [
      { id: 1, title: '第1话 合奏', updateDate: '2025-10-01' },
      { id: 2, title: '第2话 琴键上的悸动', updateDate: '2025-10-08' },
      { id: 39, title: '第39话 毕业乐章', updateDate: '2026-05-08' },
      { id: 40, title: '第40话 永恒的华尔兹（完结）', updateDate: '2026-05-15' },
    ],
  },
  {
    id: 18,
    title: '丧尸校园',
    slug: 'sangshi-xiaoyuan',
    author: '朴叙俊',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20zombie%20survival%20cover%20group%20of%20students%20barricaded%20in%20school%20hallway%20facing%20zombie%20horde%20dramatic%20emergency%20lighting%20intense%20survival%20atmosphere%20cool%20desaturated%20tones%20with%20red%20emergency%20lights%20vertical%20comic%20cover%20survival%20horror%20style&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    description: '平凡的一天，首尔某高中突然爆发丧尸病毒。被困在校园中的学生们必须在有限的资源和不断逼近的丧尸威胁中生存下去。人性在极端环境下被极端放大，信任与背叛、牺牲与利己，每一个选择都关乎生死。这部作品紧张刺激的节奏和深刻的人性探讨让人欲罢不能。',
    category: 'dongzuo',
    tags: ['丧尸', '生存', '人性', '学生'],
    status: '已完结',
    updateDate: '2026-03-20',
    totalChapters: 36,
    rating: 4.7,
    views: 5430000,
    chapters: [
      { id: 1, title: '第1话 爆发', updateDate: '2025-07-01' },
      { id: 2, title: '第2话 被困', updateDate: '2025-07-08' },
      { id: 35, title: '第35话 最后的希望', updateDate: '2026-03-13' },
      { id: 36, title: '第36话 黎明（完结）', updateDate: '2026-03-20' },
    ],
  },
  {
    id: 19,
    title: '我的ID是江南美人',
    slug: 'wode-id-shi-jiangnan-meiren',
    author: '裴秀智',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20beauty%20transformation%20cover%20confident%20young%20woman%20looking%20in%20mirror%20with%20reflection%20showing%20her%20inner%20beauty%20modern%20beauty%20salon%20setting%20warm%20and%20empowering%20atmosphere%20soft%20pink%20and%20pearl%20tones%20vertical%20comic%20cover%20empowering%20illustration%20style&width=400&height=560&seq=comic-cover-19&orientation=portrait',
    description: '曾经因为长相而备受欺凌的女孩通过整容手术获得了美貌，进入大学后开始了全新的人生。然而外表的改变真的能带来幸福吗？在经历了爱情的甜蜜与苦涩、友情的温暖与背叛后，她逐渐领悟到真正的美来自内心。本作正能量满满，细腻地探讨了容貌焦虑与自我认同。',
    category: 'wanjie',
    tags: ['整容', '校园', '成长', '自信'],
    status: '已完结',
    updateDate: '2026-04-25',
    totalChapters: 42,
    rating: 4.6,
    views: 3120000,
    chapters: [
      { id: 1, title: '第1话 新的面孔', updateDate: '2025-06-01' },
      { id: 2, title: '第2话 大学第一天', updateDate: '2025-06-08' },
      { id: 41, title: '第41话 真诚的告白', updateDate: '2026-04-18' },
      { id: 42, title: '第42话 真正的美（完结）', updateDate: '2026-04-25' },
    ],
  },
  {
    id: 20,
    title: '夜行书生',
    slug: 'yexing-shusheng',
    author: '金宇彬',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20vampire%20historical%20cover%20scholarly%20vampire%20in%20traditional%20Korean%20scholar%20robe%20under%20full%20moon%20ancient%20Korean%20architecture%20mysterious%20and%20elegant%20atmosphere%20deep%20crimson%20and%20black%20with%20silver%20moonlight%20vertical%20comic%20cover%20gothic%20historical%20fantasy%20style&width=400&height=560&seq=comic-cover-20&orientation=portrait',
    description: '朝鲜时代，一位年轻的书生在夜晚的深山中遇到了一位神秘女子，从此被卷入了吸血鬼与人类之间数百年的恩怨之中。在守护挚爱与维护人间正义之间，他将做出怎样的选择？本作融合了韩国古代历史文化与西方吸血鬼传说，画面极具东方美学韵味。',
    category: 'wanjie',
    tags: ['吸血鬼', '古装', '玄幻', '爱情'],
    status: '已完结',
    updateDate: '2026-02-28',
    totalChapters: 50,
    rating: 4.7,
    views: 2980000,
    chapters: [
      { id: 1, title: '第1话 月下的相遇', updateDate: '2025-01-20' },
      { id: 2, title: '第2话 书生的秘密', updateDate: '2025-01-27' },
      { id: 49, title: '第49话 宿命的对决', updateDate: '2026-02-21' },
      { id: 50, title: '第50话 曙光（完结）', updateDate: '2026-02-28' },
    ],
  },
  {
    id: 21,
    title: '我的老板是只猫',
    slug: 'wode-laoban-shi-zhi-mao',
    author: '林允儿',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20fantasy%20cover%20cute%20office%20worker%20holding%20talking%20cat%20in%20business%20suit%20playful%20office%20setting%20bright%20and%20cheerful%20atmosphere%20warm%20yellow%20and%20cream%20tones%20lighthearted%20comedy%20style%20vertical%20comic%20cover%20charming%20and%20funny%20illustration&width=400&height=560&seq=comic-cover-21&orientation=portrait',
    description: '新入职的广告公司员工李美娜发现，公司那位神秘又帅气的CEO竟然会在下班后变成一只猫！为了守住这个秘密，她被迫成为了CEO的"专属铲屎官"，由此展开了一系列令人捧腹的爆笑日常。轻松搞笑又温馨治愈，是解压放松的不二之选。',
    category: 'lianai',
    tags: ['搞笑', '奇幻', '职场', '治愈'],
    status: '连载中',
    updateDate: '2026-08-03',
    totalChapters: 38,
    rating: 4.4,
    views: 1560000,
    chapters: [
      { id: 1, title: '第1话 面试奇遇', updateDate: '2026-01-05' },
      { id: 2, title: '第2话 CEO的秘密', updateDate: '2026-01-12' },
      { id: 37, title: '第37话 猫与约会', updateDate: '2026-07-27' },
      { id: 38, title: '第38话 意外的告白', updateDate: '2026-08-03' },
    ],
  },
  {
    id: 22,
    title: '破镜重圆',
    slug: 'pojing-chongyuan',
    author: '全智贤',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20second%20chance%20romance%20cover%20estranged%20couple%20reuniting%20under%20cherry%20blossom%20tree%20emotional%20reunion%20scene%20soft%20spring%20lighting%20gentle%20and%20poignant%20atmosphere%20pastel%20pink%20and%20cream%20color%20palette%20vertical%20comic%20cover%20emotional%20romance%20illustration&width=400&height=560&seq=comic-cover-22&orientation=portrait',
    description: '因误会而分手的一对恋人，在五年后的大学同学会上重逢。当年的伤痛是否已经愈合？那些未曾说出口的话是否还来得及？在重新相处的过程中，两人逐渐解开了误会，也重新审视了彼此的感情。本作情感真挚，人物刻画立体，是一部让人感同身受的都市爱情作品。',
    category: 'dushi',
    tags: ['重逢', '误会', '成熟', '现实'],
    status: '已完结',
    updateDate: '2026-07-20',
    totalChapters: 44,
    rating: 4.7,
    views: 2340000,
    chapters: [
      { id: 1, title: '第1话 五年后的重逢', updateDate: '2025-11-01' },
      { id: 2, title: '第2话 刻意的疏远', updateDate: '2025-11-08' },
      { id: 43, title: '第43话 迟来的解释', updateDate: '2026-07-13' },
      { id: 44, title: '第44话 团圆（完结）', updateDate: '2026-07-20' },
    ],
  },
  {
    id: 23,
    title: '深海囚笼',
    slug: 'shenhai-qiulong',
    author: '崔胜铉',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20suspense%20cover%20lone%20figure%20trapped%20in%20underwater%20glass%20cage%20deep%20ocean%20darkness%20surrounding%20rays%20of%20light%20from%20above%20claustrophobic%20and%20intense%20atmosphere%20blue%20black%20and%20turquoise%20color%20scheme%20vertical%20comic%20cover%20psychological%20thriller%20style&width=400&height=560&seq=comic-cover-23&orientation=portrait',
    description: '一个普通的上班族在某天醒来后发现自己被困在一个深海的透明囚笼中。没有记忆，没有出口，四周只有无尽的黑暗海水。随着探索的深入，他发现了更多被困者，以及这个深海囚笼背后令人毛骨悚然的真相。本作悬念迭起，氛围营造极致，是一部不可多得的心理悬疑佳作。',
    category: 'xuanyi',
    tags: ['密室', '深海', '生存', '科幻'],
    status: '连载中',
    updateDate: '2026-08-01',
    totalChapters: 32,
    rating: 4.5,
    views: 1230000,
    chapters: [
      { id: 1, title: '第1话 醒来', updateDate: '2026-03-10' },
      { id: 2, title: '第2话 水的另一边', updateDate: '2026-03-17' },
      { id: 31, title: '第31话 真相碎片', updateDate: '2026-07-25' },
      { id: 32, title: '第32话 笼中鸟', updateDate: '2026-08-01' },
    ],
  },
  {
    id: 24,
    title: '光与影',
    slug: 'guang-yu-ying',
    author: '车银优',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20drama%20cover%20two%20contrasting%20men%20one%20in%20radiant%20light%20one%20in%20deep%20shadow%20reaching%20toward%20each%20other%20dramatic%20chiaroscuro%20lighting%20emotional%20intensity%20black%20white%20and%20gold%20tones%20vertical%20comic%20cover%20artistic%20dramatic%20style&width=400&height=560&seq=comic-cover-24&orientation=portrait',
    description: '聚光灯下的顶流演员和在幕后默默付出的经纪人，一个是万众瞩目的光，一个是无人问津的影。在娱乐圈的浮华与喧嚣中，两个截然不同的人却产生了超越职业关系的深厚感情。当秘密被曝光，当舆论如潮水般涌来，他们能否坚守彼此？',
    category: 'danmei',
    tags: ['娱乐圈', '阶级', '守护', '深情'],
    status: '连载中',
    updateDate: '2026-08-02',
    totalChapters: 54,
    rating: 4.8,
    views: 3450000,
    chapters: [
      { id: 1, title: '第1话 新任经纪人', updateDate: '2025-11-15' },
      { id: 2, title: '第2话 幕后的守护', updateDate: '2025-11-22' },
      { id: 53, title: '第53话 绯闻风暴', updateDate: '2026-07-26' },
      { id: 54, title: '第54话 选择', updateDate: '2026-08-02' },
    ],
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.category === slug);
}

export function getComicBySlug(slug: string): Comic | undefined {
  return comics.find((c) => c.slug === slug);
}

export function getHotComics(): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, 8);
}

export function getLatestComics(): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 12);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getRelatedComics(comic: Comic, limit: number = 6): Comic[] {
  return comics
    .filter((c) => c.category === comic.category && c.id !== comic.id)
    .slice(0, limit);
}